import { map } from 'rxjs/operators';
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { BaseService } from "./base.service";
import { OnDemandVideoFolderVM } from "../models";
import { HttpClient } from "@angular/common/http";

@Injectable()
export class OnDemandService extends BaseService {
  constructor(private http: HttpClient) {
    super();
  }

  public getVideos(): Observable<Array<OnDemandVideoFolderVM>> {

    var url = '/api/account/videos';

    return this.http.get(url, this.getHttpOptions(true)).pipe(
      map(resp => resp as Array<OnDemandVideoFolderVM>));
  }
}
